import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-138">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-139">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-140" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative w-full max-w-lg max-h-[80vh] bg-[#111] border border-white/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-141">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 sticky top-0 bg-[#111] z-10" data-id="element-142">
              <h2 className="text-lg font-bold text-white" data-id="element-143">{title}</h2>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-144">
                <X className="w-4 h-4 text-gray-400" data-id="element-145" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-60px)] text-sm text-gray-300 leading-relaxed space-y-4" data-id="element-146">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}